import { useNavigate } from 'react-router-dom';
import { DEV_TOKEN_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY } from '../../constants/auth';
import CompanySelector from './CompanySelector';

interface TopBarProps {
  onMenuToggle?: () => void;
}

const TopBar = ({ onMenuToggle }: TopBarProps) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      localStorage.removeItem(DEV_TOKEN_STORAGE_KEY);
      localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
    } catch {
      // ignore storage issues
    }
    navigate('/', { replace: true });
  };

  return (
    <header className="sticky top-0 z-20 flex items-center justify-between bg-white/90 px-4 py-3 shadow-sm backdrop-blur">
      <button
        type="button"
        onClick={onMenuToggle}
        className="rounded-md border border-slate-300 p-2 text-slate-600 hover:bg-slate-100 lg:hidden"
        aria-label="Toggle navigation"
      >
        ☰
      </button>
      <div className="ml-auto flex items-center gap-3">
        <CompanySelector />
        <button
          type="button"
          onClick={handleLogout}
          className="rounded-md border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-600 shadow-sm transition hover:bg-slate-100"
        >
          Log out
        </button>
      </div>
    </header>
  );
};

export default TopBar;
